module.exports = __webpack_public_path__ + "static/django-6cd6dcf11e33d7d40a75efda794cf1f6.png";